export const nextIcon = require('./nextIcon.svg');
export const prevIcon = require('./prevIcon.svg');
